// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"f2cea083","457":"543c4548","551":"b1533e79","627":"91f1a267","905":"20720c0a","923":"0a4c337d"}[chunkId] + ".chunk.js";
};